/**
 * Fetches the conversation history of a chat
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
  };

  conversationLink(e) {
    e.preventDefault();
    fetch(this.urlValue)
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
}
